import { useSession } from "../state";
import { startSocialSignIn } from "../lib/oauth";

export function FacebookButton({ label = "continue with facebook" }: { label?: string }) {
  // SessionCtx already wires Google via signInWithGoogle; we add the generic
  // helper for any IdP and call it directly here so we don't have to plumb
  // every provider into context.
  void useSession;
  return (
    <button
      type="button"
      onClick={() => startSocialSignIn("Facebook")}
      className="w-full inline-flex items-center justify-center gap-3 px-4 py-2.5 rounded-full bg-[#1877F2] text-white hover:brightness-110 transition font-medium"
    >
      <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden fill="currentColor">
        <path d="M22 12.06C22 6.48 17.52 2 12 2S2 6.48 2 12.06c0 4.97 3.66 9.1 8.44 9.88v-6.99H7.9v-2.89h2.54V9.83c0-2.51 1.49-3.89 3.77-3.89 1.09 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56v1.88h2.78l-.45 2.89h-2.34V22c4.78-.78 8.45-4.91 8.45-9.94z"/>
      </svg>
      {label}
    </button>
  );
}
